import { useState } from "react";
import { SquaresFour, CalendarBlank, House, Person, DotsThreeOutline, ChartLineUp, BookOpen, SignOut } from "@phosphor-icons/react";
import { T } from "../../themes";

const Icons = {
  routines: (c) => <SquaresFour size={24} color={c} weight="bold" />,
  plans: (c) => <CalendarBlank size={24} color={c} weight="bold" />,
  today: (c) => <House size={26} color={c} weight="fill" />,
  body: (c) => <Person size={24} color={c} weight="bold" />,
  more: (c) => <DotsThreeOutline size={24} color={c} weight="fill" />,
  history: (c) => <ChartLineUp size={20} color={c} weight="bold" />,
  library: (c) => <BookOpen size={20} color={c} weight="bold" />,
  calendar: (c) => <CalendarBlank size={20} color={c} weight="bold" />,
  logout: (c) => <SignOut size={20} color={c} weight="bold" />,
};

export default function BottomNav({ screen, onNav, onLogout }) {
  const [moreOpen, setMoreOpen] = useState(false);

  const mainItems = [
    { key: "routines", label: "Routines" },
    { key: "programmes", label: "Plans" },
    { key: "dashboard", label: "Today", center: true },
    { key: "body", label: "Body" },
    { key: "more", label: "More" },
  ];

  const moreItems = [
    { key: "history", label: "History" },
    { key: "library", label: "Library" },
    { key: "calendar", label: "Calendar" },
    { key: "logout", label: "Log Out" },
  ];

  const isActive = (key) => {
    if (key === "dashboard") return screen === "dashboard";
    if (key === "programmes") return screen === "programmes";
    if (key === "routines") return screen === "routines";
    if (key === "body") return screen === "body";
    return false;
  };

  function handleNav(key) {
    if (key === "more") {
      setMoreOpen(o => !o);
      return;
    }
    if (key === "logout") {
      setMoreOpen(false);
      onLogout();
      return;
    }
    setMoreOpen(false);
    onNav(key);
  }

  return (
    <>
      {/* More overlay */}
      {moreOpen && (
        <div
          onClick={() => setMoreOpen(false)}
          style={{
            position: "fixed", inset: 0, zIndex: 998,
            background: T.backdrop,
          }}
        />
      )}
      {moreOpen && (
        <div style={{
          position: "fixed", bottom: 80, left: "50%",
          transform: "translateX(-50%)",
          background: T.card,
          borderRadius: T.radius,
          boxShadow: T.shadow,
          padding: "8px 0",
          zIndex: 999,
          minWidth: 200,
        }}>
          {moreItems.map(item => (
            <button
              key={item.key}
              onClick={() => handleNav(item.key)}
              style={{
                width: "100%", display: "flex", alignItems: "center",
                gap: 12, padding: "12px 20px", background: "none",
                border: "none", cursor: "pointer", textAlign: "left",
              }}
            >
              {Icons[item.key]?.(
                item.key === "logout" ? T.red : T.textDim
              )}
              <span style={{
                fontSize: 13, fontWeight: 600,
                color: item.key === "logout"
                  ? (T.red) : T.ink,
                fontFamily: T.fontSans,
              }}>
                {item.label}
              </span>
            </button>
          ))}
        </div>
      )}

      {/* Nav bar */}
      <div style={{
        position: "fixed", bottom: 0, left: 0, right: 0,
        background: T.card,
        borderTop: `1px solid ${T.surface}`,
        padding: "10px 8px 16px",
        display: "flex", alignItems: "flex-end",
        justifyContent: "space-around",
        zIndex: 997,
      }}>
        {mainItems.map(item => {
          const active = isActive(item.key);
          const isCenter = item.center;
          const color = isCenter
            ? T.orange
            : active ? T.primary : T.textDim;

          if (isCenter) {
            return (
              <div
                key={item.key}
                onClick={() => handleNav(item.key)}
                style={{
                  display: "flex", flexDirection: "column",
                  alignItems: "center", gap: 4,
                  marginTop: -20, cursor: "pointer",
                }}
              >
                <div style={{
                  width: 58, height: 58, borderRadius: "50%",
                  background: T.orange,
                  display: "flex", alignItems: "center",
                  justifyContent: "center",
                  border: `3px solid ${T.card}`,
                  boxShadow: `0 6px 20px ${T.orange}55`,
                }}>
                  {Icons.today("#fff")}
                </div>
                <span style={{
                  fontSize: 11, fontWeight: 800, color: T.orange,
                  fontFamily: T.fontSans, letterSpacing: "0.3px",
                }}>
                  {item.label}
                </span>
              </div>
            );
          }

          return (
            <div
              key={item.key}
              onClick={() => handleNav(item.key)}
              style={{
                display: "flex", flexDirection: "column",
                alignItems: "center", gap: 4,
                minWidth: 44, cursor: "pointer",
              }}
            >
              <div style={{
                width: 40, height: 40,
                display: "flex", alignItems: "center",
                justifyContent: "center",
              }}>
                {(Icons[item.key] || Icons.more)?.(color)}
              </div>
              <span style={{
                fontSize: 11,
                fontWeight: active ? 700 : 500,
                color,
                fontFamily: T.fontSans,
                letterSpacing: "0.3px",
              }}>
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
}
